import { createContext, useCallback, useContext, useState } from "react";
import AlertDialog from "../components/common/inputs/AlertDialog";
import { useSnackbar } from "notistack";
import Task from "../common/Task";

export const PushContext = createContext();

export const useNotification = () => useContext(PushContext);

export const NotificationContextProvider = (props) => {

  const { enqueueSnackbar } = useSnackbar();
  const [alerts, setAlerts] = useState([]);

  const alert = useCallback(async (title = "alert", description = "", color = "error") => {
    const t = new Task();
    const data = { task: t, title, description, color };
    setAlerts(list => [...list, data]);
    await t.wait();
    setAlerts(list => list.filter(t => t !== data));
  }, []);


  const snackbar = useCallback((message = "", variant = undefined) => {
    enqueueSnackbar(message, { variant });
  }, [enqueueSnackbar]);


  return (
    <PushContext.Provider
      value={{
        alert,
        snackbar
      }}
    >

      {props.children}

      {
        alerts.length !== 0 ? (
          <AlertDialog
            task={alerts[0].task}
            title={alerts[0].title}
            description={alerts[0].description}
            color={alerts[0].color}
          />
        ) : null
      }


    </PushContext.Provider>
  );
};
